import { Tooltip as TooltipAD, TooltipProps } from "antd";
import * as React from "react";

export type { TooltipProps };

export const Tooltip: React.FC<TooltipProps> = ({ children, mouseLeaveDelay, ...props }) => {
  return (
    <TooltipAD mouseLeaveDelay={mouseLeaveDelay ?? 0} {...props}>
      {children}
    </TooltipAD>
  );
};
